/** Local prototype copy joins the ordinary i18n resource layer in resources.ts. */
export const modularLibraryCopy = {
  en: {
    currentlyReading: 'Currently reading',
    pageOf: 'Page {{page}} of {{total}}',
    readingAccessibility: '{{title}}, {{percent}} percent read. Update reading progress.',
    compactReading: '{{title}} · {{percent}}%',
    updateProgress: 'Update progress',
    returnToCenter: 'Return to the reading desk',
    recommended: 'Recommended',
    readingRitual: 'The Reading Ritual',
    ritualSteps: '2 of 3 steps',
    reward: 'Reward',
    afterword: 'Afterword',
    ratingSteps: '0 of 1 ratings',
    closeProgress: 'Close progress editor',
    currentPage: 'Current page',
    pageInput: 'Current page, from 0 to {{total}}',
    pageRuler: 'Page {{page}} of {{total}}. Adjust the page ruler.',
    pageRulerHint: 'Slide the ruler to choose your page.',
    pageValidation: 'Enter a whole page from 0 to {{total}}.',
    saveProgress: 'Save progress',
    localProgressNote: 'Preview book. Progress is kept only while this screen is open.',
    readComplete: '100% read',
  },
  sk: {
    currentlyReading: 'Práve čítate',
    pageOf: 'Strana {{page}} z {{total}}',
    readingAccessibility: '{{title}}, prečítané {{percent}} percent. Aktualizovať priebeh čítania.',
    compactReading: '{{title}} · {{percent}} %',
    updateProgress: 'Aktualizovať priebeh',
    returnToCenter: 'Späť k čitateľskému stolu',
    recommended: 'Odporúčané',
    readingRitual: 'Čitateľský rituál',
    ritualSteps: '2 z 3 krokov',
    reward: 'Odmena',
    afterword: 'Doslov',
    ratingSteps: '0 z 1 hodnotení',
    closeProgress: 'Zavrieť úpravu priebehu čítania',
    currentPage: 'Aktuálna strana',
    pageInput: 'Aktuálna strana, od 0 do {{total}}',
    pageRuler: 'Strana {{page}} z {{total}}. Upraviť pomocou pravítka strán.',
    pageRulerHint: 'Posunutím pravítka vyberte stranu.',
    pageValidation: 'Zadajte celé číslo od 0 do {{total}}.',
    saveProgress: 'Uložiť priebeh',
    localProgressNote:
      'Ukážková kniha. Priebeh zostane uložený len počas otvorenia tejto obrazovky.',
    readComplete: 'Prečítané 100 %',
  },
  cs: {
    currentlyReading: 'Právě čtete',
    pageOf: 'Strana {{page}} z {{total}}',
    readingAccessibility: '{{title}}, přečteno {{percent}} procent. Aktualizovat průběh čtení.',
    compactReading: '{{title}} · {{percent}} %',
    updateProgress: 'Aktualizovat průběh',
    returnToCenter: 'Zpět ke čtenářskému stolu',
    recommended: 'Doporučené',
    readingRitual: 'Čtenářský rituál',
    ritualSteps: '2 ze 3 kroků',
    reward: 'Odměna',
    afterword: 'Doslov',
    ratingSteps: '0 z 1 hodnocení',
    closeProgress: 'Zavřít úpravu průběhu čtení',
    currentPage: 'Aktuální strana',
    pageInput: 'Aktuální strana, od 0 do {{total}}',
    pageRuler: 'Strana {{page}} z {{total}}. Upravit pomocí pravítka stran.',
    pageRulerHint: 'Posunutím pravítka vyberte stranu.',
    pageValidation: 'Zadejte celé číslo od 0 do {{total}}.',
    saveProgress: 'Uložit průběh',
    localProgressNote:
      'Ukázková kniha. Průběh zůstane uložený jen po dobu otevření této obrazovky.',
    readComplete: 'Přečteno 100 %',
  },
} as const;
